import { useMemo } from 'react';
import { IntegrationKey, type PaymentAccount } from '@erp/rpc';
import { useGetIntegration } from './useIntegrations';

/**
 * Hook for fetching the organization's payment accounts from the Payments integration.
 * Returns all accounts, verified-only accounts, and the default account.
 */
export function usePaymentAccounts() {
  const { data: integration, isLoading } = useGetIntegration(
    IntegrationKey.Payments,
  );

  const accounts: PaymentAccount[] = useMemo(() => {
    if (integration?.key === IntegrationKey.Payments) {
      return integration.settings.accounts;
    }
    return [];
  }, [integration]);

  const verifiedAccounts = useMemo(
    () => accounts.filter((a) => a.checkbookStatus === 'VERIFIED'),
    [accounts],
  );

  const defaultAccount = useMemo(
    () => verifiedAccounts.find((a) => a.isDefault) ?? verifiedAccounts[0],
    [verifiedAccounts],
  );

  return { accounts, verifiedAccounts, defaultAccount, isLoading };
}
